import React,{useState,useEffect} from 'react';
import { connect } from "react-redux";
import CheckoutItem from "../../components/checkout-item/checkout-item.component";
import { createStructuredSelector } from "reselect";
import { selectCartItems,selectCartTotal } from "../../redux/cart/cart.selectors";
import CashOnDelivery from '../../components/cashondelivery/cashondelivery.component'
import './checkout.styles.scss';
import {Helmet} from 'react-helmet'
// import FormInput from '../../components/form-input/form-input.component';
import {selectCurrentUser} from '../../redux/user/user.selectors'
import CustomButton from '../../components/custom-button/custom-button.component';

const CheckoutPage = ({cartItems,total,currentUser}) => {
    const [p,setP] = useState('checkout')
    const handlePay = () => {
        setP("payment")
    }
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
  return(  
      <>   
        {/* <Helmet>
        <meta charset="utf-8"/>
        <meta name="viewport" content="width=device-width, initial-scale=1"/>
        <meta name="description" content="Checkout now and complete your order of gadgets and accessories on Acceronix."/>
        <title>Checkout Gadgets and Accessories | Acceronix</title>
        </Helmet> */}
        { p === "checkout" ?
        <div className="checkout">
        <div className="checkout-page">
        <div className="checkout-header">
            <div className="header-block">
                <span>Product</span>
            </div>
            <div className="header-block">
                <span>Description</span>
            </div>
            <div className="header-block">
                <span>Quantity</span>
            </div>
            <div className="header-block">
                <span>Price</span>
            </div>
            <div className="header-block">
                <span>Remove</span>
            </div>
        </div>
        {
            cartItems.map(cartItem => 
                <CheckoutItem key={cartItem.id} cartItem={cartItem}/>
            )
        }
        <div className="total">
            <span>TOTAL: RP{total}</span>
        </div>
        {
            currentUser ? <div>
       
                {currentUser.entries >= total ?  <CustomButton type="button" onClick={handlePay} aria-label="Procced to Payment">Proceed to Payment</CustomButton>:<div/> }
            </div>
            :<div/>
        }
    </div> 
    <div className="delivery">
    </div>
    </div>
    :
    <CashOnDelivery cartItems={cartItems} total={total}/>
    }
    </>
)}
const mapStateToProps = createStructuredSelector({
    cartItems : selectCartItems,
    total: selectCartTotal,
    currentUser:selectCurrentUser,
})
export default connect(mapStateToProps)(CheckoutPage);